<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps"/>
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input type="text" name="name" v-model="humor.name" value="" placeholder="Nome" required/>
          </div>
        </div>
        <div class="col-12">
          <UploadImage @changePicture="(value) => humor.picture = value" :proportion="'Proporção: 33x33'"/>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import UploadImage from '@/components/upload/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Humor',
          routerName: 'Humor'
        },
        {
          name: 'Novo Humor',
          routerName: 'RegisterHumor'
        },
      ],
      humor: {
        id_user: "",
        name: '',
        picture: null,
        is_premium: false
      },
      humorParams: this.$route.params,
      selectedCategory: '',
      dataProps: { module: 'Humor' },
    }
  },
  computed: {
    ...mapGetters({
      user: 'User/user',
      humorData: 'Humor/humor',
      isPremium: 'Humor/isPremium'
    })
  },
  components: {
    Breadcrumb,
    UploadImage
  },
  methods: {
    ...mapActions('Humor', ['registerHumor', 'consultMoods', 'setDataDefault']),
    ...mapActions(['setImageFileUrl']),
    async handleSubmit(){
      let message = this.humor?.id ? 'Humor editado com sucesso!' : 'Humor cadastrado com sucesso!';

      this.humor.is_premium = this.isPremium;

      await this.registerHumor(this.humor);
      this.$router.push({ name: 'Humor' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
  },
  async mounted() {
    this.humor.id_user = await this.user.id;
    this.setImageFileUrl(null);
    if (this.humorParams && Object.keys(this.humorParams).length > 0) {
      await this.consultMoods(this.humorParams);
      this.dataProps = {
        name: this.humorData.name,
        id: this.humorParams.id,
        module: 'Humor',
        type: 'Humor'
      };
      this.humor = this.humorData;
      this.setDataDefault(['SET_IS_PREMIUM', this.humor.is_premium]);
      this.links[1].name = this.humor.name;
      this.setImageFileUrl(this.humor.picture);
    }
  }
}
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
